<div class="flex w-full flex-col gap-5 text-base">
  <div class="flex flex-col gap-1">
    <span class="header text-navy-90 font-bold">{{ buildTranslationKey('header') | translate }}</span>

    <span class="description text-navy-70" [innerHTML]="buildTranslationKey('description') | translate"></span>
  </div>

  <ng-container *ngVar="(contactLists$ | async) as contactLists">
    <app-tip class="approval-tip w-full" [tipType]="TipTypeEnum.TIP">{{ buildTranslationKey('tip') | translate }}</app-tip>

    <div class="flex gap-3">
      <app-new-button
        class="evidence-pool-btn"
        [disabled]="contactLists?.length >= MAX_ALLOWED_LISTS"
        [type]="'secondary'"
        [size]="'responsive-no-padding'"
        [svgIconPath]="'evidence-pool-v2'"
        (click)="openEvidencePoolModal()">
        {{ buildTranslationKey('addFromEvidencePool') | translate }}
      </app-new-button>
      <div 
        class="inline-block"
        [placement]="'top'"
        [ngbTooltip]="isEvidenceLabDisabled ? (buildTranslationKey('disableTooltip') | translate) : undefined">
        <app-new-button
          class="evidence-lab-btn"
          [disabled]="isEvidenceLabDisabled || contactLists?.length >= MAX_ALLOWED_LISTS"
          [type]="'secondary'"
          [size]="'responsive-no-padding'"
          [svgIconPath]="'Add'"
          [ngbTooltip]="createTooltip"
          [placement]="'bottom'"
          (click)="navigateToEvidenceLab()">
          {{ buildTranslationKey('createWithEvidenceLab') | translate }}
        </app-new-button>
      </div>
    </div>
    @if (contactLists?.length) {
      @for (list of contactLists; track list.id) {
        <app-contact-list class="contact-list" [contactList]="list"></app-contact-list>
      }
    }
  </ng-container>
</div>

<ng-template #createTooltip>
  <span class="whitespace-pre-line">{{ buildTranslationKey('createTooltip') | translate }}</span>
</ng-template>
